import React from 'react';
import { t } from '@lingui/macro';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { WhatsNew } from 'components/WhatsNew/WhatsNew';
import { WhatsNewLoader } from 'components/WhatsNew/WhatsNewLoader/WhatsNewLoader';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';

export const WhatsNewPage = () => {
  const { introducerId } = useIntroducerContext();

  return (
    <BaseLayout
      pageTitle={t`What's new | Introducer Portal`}
      contentPadding={false}
    >
      {introducerId ? (
        <WhatsNew introducerId={introducerId} />
      ) : (
        <WhatsNewLoader />
      )}
    </BaseLayout>
  );
};
